import { render, staticRenderFns } from "./ClientGeneralForm.vue?vue&type=template&id=709899a6&scoped=true&"
import script from "./ClientGeneralForm.vue?vue&type=script&lang=js&"
export * from "./ClientGeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709899a6",
  null
  
)

export default component.exports